import React, {Component} from "react";

import * as CommonUtils from "../../utils/CommonUtils";
import * as ModalUtils from "../../utils/ModalUtils";

import favIconPng from "../../../resources/icon/png/mutasudoku_logo.png";
import logoNameSvg from "../../../resources/icon/svg/common/mutasudoku_logo_name.svg";
import logoImageSvg from "../../../resources/icon/svg/common/mutasudoku_logo.svg";
import returnSvg from "../../../resources/icon/svg/blue/return.svg";
import ruStoreSvg from "../../../resources/icon/svg/common/icon_ru_store.svg";
import huaweiStoreSvg from "../../../resources/icon/svg/common/icon_huawei_app_gallery.svg";
import playMarketSvg from "../../../resources/icon/svg/common/icon_playmarket.svg";
import amazonAppStoreSvg from "../../../resources/icon/svg/common/icon_amazon_app_store.svg";
import oppoAppMarketSvg from "../../../resources/icon/svg/common/icon_oppo_app_market.svg";
import xiaomiAppStoreSvg from "../../../resources/icon/svg/common/icon_xiaomi_app_store.svg";

export default class MutaSudokuPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            refreshId:""
        };
    }

    componentDidMount() {
        CommonUtils.changePageTitle('MutaSudoku')
        CommonUtils.changePageFavIcon(favIconPng);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextState.refreshId !== this.state.refreshId;
    }

    render() {
        return (
            <div className={'mainPageDiv'}>
                <img src={returnSvg} className={'returnButton'} alt=''
                     onClick={ () => {
                         let spinner = ModalUtils.showMutaSpinner();
                         setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=main') }, 1000)
                     }}/>
                <img src={logoNameSvg} className={'mainPageLogoName'} alt=''/>
                <img src={logoImageSvg} className={'standaloneLogoImage'} alt={''}/>

                <iframe className={'standaloneYoutubeVideo'} width={'45%'} height={'40%'} frameBorder={'0'} src="http://www.youtube.com/embed/OjwgSgctI-Y" allowFullScreen/>

                <div className={'appStoresDiv'}>
                    <img className={'mutanoidsGameChannelsDivItem'} src={ruStoreSvg} alt={''} title={'RuStore'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={huaweiStoreSvg} alt={''} title={'Huawei App Gallery'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={playMarketSvg} alt={''} title={'Google Play Market'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={amazonAppStoreSvg} alt={''} title={'Amazon App Store'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={oppoAppMarketSvg} alt={''} title={'Oppo App Market'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={xiaomiAppStoreSvg} alt={''} title={'Xiaomi App Store'}/>
                </div>

                <div className={'privacyPolicyDiv noSelect'}
                     onClick={ () => {
                         let spinner = ModalUtils.showMutaSpinner();
                         setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=privacyPolicyMutaSudoku') }, 1000)
                     }}>
                    {'Privacy policy'}
                </div>
                {CommonUtils.getAppVersionNameDiv()}
            </div>
        )
    }
}